import defaultTheme from './default';
import css from '../../../utils/css';

export default defaultTheme +
  css`
    :host {
      --widget-font-family: 'Ariana Pro', sans-serif;

      --jockeyclub-black: #000;
      --jockeyclub-green: #062d2d;
      --jockeyclub-gold: #af9664;
      --jockeyclub-turquoise: #4ac8d7;
      --jockeyclub-white: #fff;

      --widget-text-color: var(--jockeyclub-green);

      --widget-header-bg-color: var(--jockeyclub-black);
      --widget-header-text-color: var(--jockeyclub-gold);
      --widget-header-odds-shadow: #ccc;

      --widget-grid-compare-active-bg-color: var(--jockeyclub-turquoise);
      --widget-grid-compare-color: var(--jockeyclub-green);

      --widget-mobile-seeall-color: var(--jockeyclub-black);

      --widget-grid-best-odds-text-color: var(--jockeyclub-white);
    }
  `;
